import React, { useState } from "react";
import { Colorize, FilterList } from "@mui/icons-material";
import { Box, Checkbox, IconButton, Tooltip, Typography } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@mui/material/Paper";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Popover from "../Popover/Popover";
// import { createCSVDownload, downloadCSV } from "../utils";
// import find from "lodash.find";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function ToolBar({
  searchField,
  setSearchField,
  name,
  columns,
  rows,
  displayColumns,
  setDisplayColumns,
  options,
  setRowfilters,
  rowFilters,
}) {
  const [hidePopover, setHidePopover] = useState(false);

  const filterPopoverExit = () => {
    setHidePopover(false);
    // this.setActiveIcon();
  };

  const closeFilterPopover = () => {
    setHidePopover(true);
  };

  // const handleCSVDownload = () => {
  //   const { data, displayData, columns, options, columnOrder } = this.props;
  //   let dataToDownload = []; //cloneDeep(data);
  //   let columnsToDownload = [];
  //   let columnOrderCopy = Array.isArray(columnOrder)
  //     ? columnOrder.slice(0)
  //     : [];

  //   if (columnOrderCopy.length === 0) {
  //     columnOrderCopy = columns.map((item, idx) => idx);
  //   }

  //   data.forEach((row) => {
  //     let newRow = { index: row.index, data: [] };
  //     columnOrderCopy.forEach((idx) => {
  //       newRow.data.push(row.data[idx]);
  //     });
  //     dataToDownload.push(newRow);
  //   });

  //   columnOrderCopy.forEach((idx) => {
  //     columnsToDownload.push(columns[idx]);
  //   });

  //   if (options.downloadOptions && options.downloadOptions.filterOptions) {
  //     // check rows first:
  //     if (options.downloadOptions.filterOptions.useDisplayedRowsOnly) {
  //       let filteredDataToDownload = displayData.map((row, index) => {
  //         let i = -1;

  //         // Help to preserve sort order in custom render columns
  //         row.index = index;

  //         return {
  //           data: row.data.map((column) => {
  //             i += 1;

  //             // if we have a custom render, which will appear as a react element, we must grab the actual value from data
  //             // that matches the dataIndex and column
  //             // TODO: Create a utility function for checking whether or not something is a react object
  //             let val =
  //               typeof column === "object" &&
  //               column !== null &&
  //               !Array.isArray(column)
  //                 ? find(data, (d) => d.index === row.dataIndex).data[i]
  //                 : column;
  //             val =
  //               typeof val === "function"
  //                 ? find(data, (d) => d.index === row.dataIndex).data[i]
  //                 : val;
  //             return val;
  //           }),
  //         };
  //       });

  //       dataToDownload = [];
  //       filteredDataToDownload.forEach((row) => {
  //         let newRow = { index: row.index, data: [] };
  //         columnOrderCopy.forEach((idx) => {
  //           newRow.data.push(row.data[idx]);
  //         });
  //         dataToDownload.push(newRow);
  //       });
  //     }

  //     // now, check columns:
  //     if (options.downloadOptions.filterOptions.useDisplayedColumnsOnly) {
  //       columnsToDownload = columnsToDownload.filter(
  //         (_) => _.display === "true"
  //       );

  //       dataToDownload = dataToDownload.map((row) => {
  //         row.data = row.data.filter(
  //           (_, index) => columns[columnOrderCopy[index]].display === "true"
  //         );
  //         return row;
  //       });
  //     }
  //   }
  //   createCSVDownload(columnsToDownload, dataToDownload, options, downloadCSV);
  // };

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignContent: "space-around",
        alignItems: "center",
        minHeight: "70px",
        marginBottom: "20px",
        padding: "20px",
        backgroundColor: "#edf0e9",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: 400,
        }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1, borderBottom: "solid 1px" }}
          placeholder="Search..."
          value={searchField}
          onChange={(e) => setSearchField(e.target.value)}
          inputProps={{ "aria-label": "search google maps" }}
        />
        <IconButton
          type="button"
          // sx={{ p: "10px" }}
          aria-label="search"
        >
          <SearchIcon />
        </IconButton>
      </Box>

      <Box sx={{ marginLeft: "auto" }}>
        <Tooltip title="Download">
          <IconButton>
            <CloudDownloadIcon />
          </IconButton>
        </Tooltip>

        <Popover
          refExit={filterPopoverExit}
          hide={hidePopover || options?.filter === "disabled"}
          classes={{
            closeIcon: null,
          }}
          trigger={
            <Tooltip title={"Columns"} disableFocusListener>
              <IconButton>
                <ViewColumnIcon />
              </IconButton>
            </Tooltip>
          }
          content={
            <Box
              sx={{
                margin: "20px",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                columnGap: "20px",
                rowGap: "20px",
              }}
            >
              {displayColumns?.map((item, i) => (
                <Box key={item.i}>
                  <Checkbox
                    key={item.i}
                    checked={"display" in item ? item.display : true}
                    onChange={(e) => {
                      const copyState = [...columns];
                      // console.log(displayColumns, item);

                      const column = copyState.find(
                        (column) => column.id === item.id
                      );

                      column.display = e.target.checked;

                      setDisplayColumns(copyState);
                    }}
                  />
                  {item.name}
                </Box>
              ))}
            </Box>
          }
        />

        <Popover
          refExit={filterPopoverExit}
          hide={hidePopover || options?.filter === "disabled"}
          classes={{
            closeIcon: null,
          }}
          trigger={
            <Tooltip title={"Filter Table"} disableFocusListener>
              <IconButton>
                <FilterList />
              </IconButton>
            </Tooltip>
          }
          content={
            <Box
              sx={{
                margin: "20px",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                columnGap: "20px",
                rowGap: "20px",
              }}
            >
              {columns?.map((column) => {
                if (column.customFilter) {
                  return column.customFilter;
                } else {
                  return (
                    <Autocomplete
                      multiple
                      id="checkboxes-tags-demo"
                      options={rows
                        .map((item) => item[column.id])
                        ?.filter(onlyUnique)
                        .map((item) => ({ title: item }))}
                      value={
                        rowFilters.find((item) => item.column === column.id)
                          ?.values || []
                      }
                      onChange={(e, newValues) => {
                        const copyState = [...rowFilters];

                        const oldValues = copyState.find(
                          (item) => item.column === column.id
                        );

                        const oldValuesIndex = copyState.findIndex(
                          (item) => item.column === column.id
                        );

                        // console.log(newValues);

                        if (!oldValues) {
                          copyState.push({
                            column: column.id,
                            values: newValues,
                          });
                        } else if (!newValues[0]) {
                          copyState.splice(oldValuesIndex, 1);
                        } else {
                          oldValues.values = newValues;
                        }

                        setRowfilters(copyState);
                      }}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.title}
                      isOptionEqualToValue={(option, value) =>
                        option.title === value.title
                      }
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.title}
                        </li>
                      )}
                      style={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={column.name}
                          placeholder="Search..."
                        />
                      )}
                    />
                  );
                }
              })}
            </Box>
          }
        />
      </Box>
    </Paper>
  );
}

export default ToolBar;
